import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from '@oceanjs/core';
import clsx from 'clsx';
import { useEffect } from 'react';
import { useMainMenuVisible, useSetMainMenuVisible } from '../../state/mainMenu';
import { useThemeValue } from '../../state/theme';
import { getFlexItemClasses } from '../../utils/getFlexItemClasses';
import { Flex } from '../Flex';
/**
 * Container for the main menu
 */
export const MainMenu = (props) => {
    const { children } = props;
    const location = useLocation();
    const forcedVisible = useMainMenuVisible();
    const setMainMenuVisibile = useSetMainMenuVisible();
    const borderClass = useThemeValue('divider-color', 'border-gray-200');
    const widthClass = useThemeValue('main-menu-width', 'w-56');
    useEffect(() => {
        setMainMenuVisibile(false);
    }, [location, setMainMenuVisibile]);
    return (_jsx("nav", Object.assign({ className: clsx(getFlexItemClasses({ shrink: false }), forcedVisible ? ['w-full xl:w-56'] : ['hidden xl:block border-r', borderClass, widthClass]) }, { children: _jsx(Flex, Object.assign({ column: true, className: "sticky top-20" }, { children: children }), void 0) }), void 0));
};
//# sourceMappingURL=MainMenu.js.map